import { HTMLAttributes, ReactNode, SyntheticEvent } from 'react';

import { twMerge } from 'tailwind-merge';
import { Button } from '../../../components/Clickables/Buttons/Button';
import { trackEvent } from '../../../helpers/analytics/trackEvent';
import { EventMykissCardClicked } from '../../../interfaces/events';

interface FishingReportCardButtonProps extends HTMLAttributes<HTMLElement> {
  children?: ReactNode;
  className?: string;
  disabled?: boolean;
  eventProperties: EventMykissCardClicked['properties'];
  onClick?: (event: SyntheticEvent) => void;
  ariaLabel: string;
}

export const FishingReportCardButton = ({
  children,
  className,
  disabled,
  eventProperties,
  onClick,
  ariaLabel,
  ...rest
}: FishingReportCardButtonProps) => {
  const handleOnClick = (event: SyntheticEvent): void => {
    if (onClick) {
      onClick(event);
    }
    void trackEvent({
      name: 'mykiss_card_clicked',
      properties: eventProperties,
    });
  };

  return (
    <div className={twMerge('relative w-full', className)}>
      <Button
        variant="buttonNone"
        onClick={handleOnClick}
        className="absolute inset-0"
        aria-label={ariaLabel}
        disabled={disabled}
        {...rest}
      ></Button>
      <div className="pointer-events-none relative z-1">{children}</div>
    </div>
  );
};
